import React, { useEffect, useState } from "react";
import api from "../../../api/axiosConfig";
import "../../../css/TeleRoleAssignment.css";
import { showToast } from '../../Shared/Toaster';


interface Role {
  _id: string;
  name: string;
}

interface Props {
  userId: string;
  userEmail: string;
  userName: string;
  onClose: () => void;
}

const RoleAssignmentModal: React.FC<Props> = ({
  userId,
  userEmail,
  userName,
  onClose,
}) => {
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const [formData, setFormData] = useState({
    roleId: "",
    status: "ACTIVE",
    notes: "",
  });

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const token = sessionStorage.getItem("accessToken");

      const res = await api.auth_api.get("/roles", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setRoles(res.data);
    } catch (err) {
      console.error("Error fetching roles:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.roleId) {
      showToast("Please select a role", 'error');
      return;
    }

    try {
      setUpdating(true);

      const token = sessionStorage.getItem("accessToken");

      await api.auth_api.post(
        `/users/${userId}/roles`,
        {
          roleId: formData.roleId,
          status: formData.status,
          notes: formData.notes,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      showToast("✅ Role assigned successfully!", 'success');
      onClose();

    } catch (err) {
      console.error("Error assigning role:", err);
      showToast("Failed to assign role", 'error');
    } finally {
      setUpdating(false);
    }
  };

  return (
  <div className="role-assign-overlay">
    <div className="role-assign-modal">

      <div className="role-assign-header">
        <h2>Assign Role to Doctor</h2>
        <button className="role-assign-close" onClick={onClose}>
          ×
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="role-assign-body">

          <div className="role-assign-field">
            <label>Email</label>
            <p>{userEmail}</p>
          </div>

          <div className="role-assign-field">
            <label>Name</label>
            <p>{userName}</p>
          </div>

          <div className="role-assign-field">
            <label>Role</label>
            {loading ? (
              <p>Loading roles...</p>
            ) : (
              <select
                value={formData.roleId}
                onChange={(e) =>
                  setFormData({ ...formData, roleId: e.target.value })
                }
                required
              >
                <option value="">Select Role</option>
                {roles.map((role) => (
                  <option key={role._id} value={role._id}>
                    {role.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="role-assign-field">
            <label>Status</label>
            <select
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
            >
              <option value="ACTIVE">Active</option>
              <option value="DISABLED">Disabled</option>
            </select>
          </div>

          <div className="role-assign-field">
            <label>Notes</label>
            <textarea
              rows={3}
              value={formData.notes}
              onChange={(e) =>
                setFormData({ ...formData, notes: e.target.value })
              }
            />
          </div>

        </div>

        <div className="role-assign-footer">
          <button
            type="button"
            className="role-assign-btn cancel"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="role-assign-btn primary"
            disabled={updating}
          >
            {updating ? "Assigning..." : "Assign Role"}
          </button>
        </div>
      </form>
    </div>
  </div>
);
};

export default RoleAssignmentModal;